import { Box, Typography, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TriangleAlert, Radio } from "lucide-react";
import { useNavigate } from "react-router-dom";

const WideTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--dk-surface, #fff)",
    color: "#212121",
    border: "0.5px solid var(--dk-border, #e0e0e0)",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    padding: "12px 14px",
    maxWidth: 240,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#fff",
    "&::before": { border: "0.5px solid var(--dk-border, #e0e0e0)" },
  },
});

export default function SWProgressWarning() {
  const navigate = useNavigate();

  const tooltipContent = (
    <Box id="warning-sw-icon">
      <Typography sx={{ fontSize: "12px", color: "text.primary", lineHeight: 1.6, mb: "10px" }}>
        서비스 워커가 연결되어 있지 않아 진행률을 실시간으로 표시할 수 없습니다. 학습은 정상적으로 진행됩니다.
      </Typography>
      <Box
        onClick={() => navigate("/main/setting")}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          px: "10px",
          py: "5px",
          borderRadius: "6px",
          border: "0.5px solid var(--dk-border, #e0e0e0)",
          bgcolor: "var(--dk-surface-2, #fafafa)",
          cursor: "pointer",
          transition: "all 0.15s",
          "&:hover": { bgcolor: "var(--dk-surface-3, #f0f0f0)", borderColor: "#bdbdbd" },
        }}
      >
        <Radio size={12} color="#1976d2" />
        <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "#1976d2" }}>SW 상태 확인하기</Typography>
      </Box>
    </Box>
  );

  return (
    <WideTooltip title={tooltipContent} placement="top" arrow>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "0.5px solid #ffe082",
          bgcolor: "#fff8e1",
          color: "#f59f00",
          cursor: "default",
          transition: "border-color 0.15s",
          "&:hover": { borderColor: "#f59f00" },
        }}
      >
        <TriangleAlert size={14} />
      </Box>
    </WideTooltip>
  );
}
